export default __webpack_public_path__ + "static/media/share.c3b0b027.gif";